import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, HashRouter as Router, Route } from "react-router-dom";
import Navbar from "./component/Navbar";
import LandingPage from "./pages/Landingpage.js";
import Footer from "./component/Footer";

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}
